module.exports = __webpack_public_path__ + "static/media/access-anywhere.4910b256.svg";